/*eslint-disable */
import { AxiosInstance } from 'axios'
import { getCookie } from 'cookies-next'
import { IRequestConfig, IRequestOptions } from '@/shared/services/index'

// Add options interface
interface ServiceOptions {
  axios?: AxiosInstance
}

// Add default options
export const serviceOptionsVoical: ServiceOptions = {}

// Instance selector
function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptionsVoical.axios) {
    return serviceOptionsVoical.axios
      .request(configs)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  } else {
    throw new Error('please inject yourself instance like axios  ')
  }
}

function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url }
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType,
    Authorization: getCookie('access-token') ? 'Bearer ' + getCookie('access-token') : ''
  }
  return configs
}

const basePath = ''

export class VoiceCallPackageService {

  /**
     * Tạo gói dịch vụ mới
     */
  static createPackage(
    params: {
      body: {
        /** Tên gói */
        name: string
        /** Giá tiền */
        price: number
        /** Loại gói */
        type: number
        /** Thời hạn sử dụng (tháng) */
        time_use_duration: number
        /** Thời lượng gọi AI (phút) */
        ai_time_use_duration: number
        /** Số lượng kịch bản */
        total_scenario: number
        /** Số lượng số điện thoại */
        total_phone: number
        /** Số lượng thành viên tổ chức */
        total_organization_member: number
      }
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/admin/package'
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }

  /**
   * Lấy danh sách package
   */
  static getPackages(
    params: {
      /** Từ khóa tìm kiếm */
      keyword?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/admin/package'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        keyword: params.keyword,
        page: params.page ?? 0,
        size: params.size ?? 10
      }
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Lấy danh sách package
   */
  static getUserPackages(
    params: {
      /** Từ khóa tìm kiếm */
      keyword?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/package'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        keyword: params.keyword,
        page: params.page ?? 0,
        size: params.size ?? 10
      }
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Cập nhật package
   */
  static updatePackage(
    params: {
      /** ID package */
      id: string,
      /** requestBody */
      body: {
        /** Tên gói */
        name?: string
        /** Giá */
        price?: number
        /** Loại gói (0: gói chính, 1: gói add-on) */
        type?: number
        /** Thời hạn sử dụng (tháng) */
        time_use_duration?: number
        /** Thời lượng gọi AI (phút) */
        ai_time_use_duration?: number
        /** Số lượng kịch bản */
        total_scenario?: number
        /** Số lượng số điện thoại */
        total_phone?: number
        /** Số lượng thành viên tổ chức */
        total_organization_member?: number
        /** Trạng thái */
        status?: number
        /** Trạng thái hiển thị */
        display_status?: number
      }
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/package/' + encodeURIComponent(params.id)
      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }

  /**
   * Lấy danh sách order (đơn hàng)
   */
  static getOrders(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/order'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        page: params.page ?? 0,
        size: params.size ?? 10
      }
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Lấy danh sách order (đơn hàng)
   */
  static getAdminOrders(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/admin/order'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        page: params.page ?? 0,
        size: params.size ?? 10
      }
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Kích hoạt đơn hàng
   */
  static executeOrder(
    params: {
      /** ID đơn hàng */
      id: string
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/order/{id}/execute'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Kích hoạt đơn hàng
   */
  static executeAdminOrder(
    params: {
      /** ID đơn hàng */
      id: string
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/order/{id}/execute'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Lấy lịch sử sử dụng gói (package active)
   */
  static getActivePackages(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/package/active'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Tạo đơn hàng (admin)
   */
  static createAdminOrder(
    params: {
      body: {
        email: string
        package_id: string
        start_time: number
      }
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/admin/order'
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }

  /**
   * Hủy đơn hàng (admin)
   */
  static cancelAdminOrder(
    params: {
      /** ID đơn hàng */
      id: string
      /** requestBody */
      body: {
        /** Ghi chú hủy đơn */
        note: string
      }
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/order/{id}/cancel'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }
}

export class ScenarioService {
  /**
   *
   */
  static getScenarioInfo(
    params: {
      /**  */
      scenarioId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static getInboundScenarioInfo(
    params: {
      /**  */
      inboundId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/inbound/{inboundId}'
      url = url.replace('{inboundId}', params['inboundId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Test voice call
   */
  static testVoice(
    params: {
      /** requestBody */
      body?: {
        text: string
        voice_id: string
        speed: number
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/voice/test'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updateScenario(
    params: {
      /**  */
      scenarioId: string
      /** requestBody */
      body?: {
        name: string
        bot_name: string
        bot_style_id: string
        category_id: string
        category_prompt: string
        prompt: string
        voice_id: string
        voice_speed: number
        first_message: string
        description: string
        bot_role_id: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static updateIncallScenario(
    params: {
      /**  */
      inboundId: string
      /** requestBody */
      body?: {
        name: string
        bot_name: string
        bot_style_id: string
        category_id: string
        category_prompt: string
        prompt: string
        voice_id: string
        voice_speed: number
        first_message: string
        description: string
        bot_role_id: string
        trunk_provider_id: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/inbound/{inboundId}'
      url = url.replace('{inboundId}', params['inboundId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static deleteScenario(
    params: {
      /**  */
      scenarioId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static deleteInboundScenario(
    params: {
      /**  */
      inboundId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/inbound/{inboundId}'
      url = url.replace('{inboundId}', params['inboundId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updateScenarioAction(
    params: {
      /**  */
      scenarioId: string
      /**  */
      scenarioActionId: string
      /** requestBody */
      body?: UpdateScenarioActionRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}/action/{scenarioActionId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')
      url = url.replace('{scenarioActionId}', params['scenarioActionId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static deleteScenarioAction(
    params: {
      /**  */
      scenarioId: string
      /**  */
      scenarioActionId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}/action/{scenarioActionId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')
      url = url.replace('{scenarioActionId}', params['scenarioActionId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static getListScenario(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createScenario(
    params: {
      /** requestBody */
      body?: CreateScenarioRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createScenarioAction(
    params: {
      /**  */
      scenarioId: string
      /** requestBody */
      body?: CreateScenarioActionRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}/action'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static searchScenario(
    params: {
      /** Từ khóa tìm kiếm */
      keyword?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/outbound'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { keyword: params['keyword'], page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static searchIncallScenario(
    params: {
      /** Từ khóa tìm kiếm */
      keyword?: string
      /** Số điện thoại */
      phone_number?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/inbound'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { keyword: params['keyword'], phone_number: params['phone_number'], page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Verify scenario name
   */
  static verifyScenarioName(
    params: {
      /** Tên kịch bản */
      name: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/name/verify'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.params = { name: params['name'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Get scenario config
   */
  static getScenarioConfig(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/config'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   * Generate scenario prompt
   */
  static generateScenarioPrompt(
    params: {
      /** requestBody */
      body?: {
        category_id: string,
        prompt: string,
        data: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/prompt'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Generate scenario prompt
   */
  static generateIncallScenarioPrompt(
    params: {
      /** requestBody */
      body?: {
        category_id: string,
        prompt: string,
        data: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/inbound/prompt'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   * Test scenario
   */
  static testScenario(
    params: {
      /** requestBody */
      body?: {
        name: string
        bot_name: string
        bot_style_id: string
        category_id: string
        prompt: string
        voice_id: string
        voice_speed: number
        phone_number: string
        first_message: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/test'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Create scenario
   */
  static createScenarioExternal(
    params: {
      /** requestBody */
      body?: {
        name: string
        bot_name: string
        bot_style_id: string
        category_id: string
        category_prompt: string
        prompt: string
        voice_id: string
        voice_speed: number
        first_message: string
        description: string
        bot_role_id: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static createIncallScenarioExternal(
    params: {
      /** requestBody */
      body?: {
        name: string
        bot_name: string
        bot_style_id: string
        category_id: string
        category_prompt: string
        prompt: string
        voice_id: string
        voice_speed: number
        first_message: string
        description: string
        bot_role_id: string
        trunk_provider_id: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/inbound'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class CampaignService {
  /**
   *
   */
  static getListCampaign(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createCampaign(
    params: {
      /** requestBody */
      body?: CreateCampaignRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static deleteCampaign(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  /**
   *
   */
  static updateCampaignInfo(
    params: {
      /**  */
      campaignId: string
      /** requestBody */
      body?: CreateCampaignRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static getCampaignInfo(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */

  static getCampaignCustomerInfo(
    params: {
      /**  */
      campaignId: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}/customer'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  static runCampaign(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}/run'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */

  /**
   *
   */
  static stopCampaign(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}/stop'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static copyCampaign(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}/copy'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  /**
   *
   */
  static searchCampaign(
    params: {
      /** Từ tìm kiếm */
      keyword?: string
      /** Trạng thái */
      status?: string
      /** Id kịch bản */
      scenarioId?: string
      /** Từ ngày */
      fromDate?: number
      /** Đến ngày */
      toDate?: number
      /** Id giọng nói */
      voiceId?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/search'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        keyword: params['keyword'],
        status: params['status'],
        scenario_id: params['scenarioId'],
        from_date: params['fromDate'],
        to_date: params['toDate'],
        voice_id: params['voiceId'],
        page: params['page'],
        size: params['size']
      }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class AgentService {
  /**
   *
   */
  static getListAgent(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agent'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class VoiceService {
  /**
   *
   */
  static getListVoice(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/voice'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class CustomerService {
  /**
   *
   */
  static getCustomerInfo(
    params: {
      /**  */
      customerId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}'
      url = url.replace('{customerId}', params['customerId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updateCustomerInfo(
    params: {
      /**  */
      customerId: string
      /** requestBody */
      body?: UpdateCustomerRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}'
      url = url.replace('{customerId}', params['customerId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static deleteCustomerInfo(
    params: {
      /**  */
      customerId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}'
      url = url.replace('{customerId}', params['customerId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static getListCustomerInfo(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
      /** Từ khóa */
      keyword?: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/search'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'], keyword: params['keyword'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createCustomer(
    params: {
      /** requestBody */
      body?: CreateCustomerRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createListCustomerByFile(
    params: {
      /**  */
      file: any
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/upload'

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options)

      let data = new FormData()
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any)
          }
        } else {
          data.append('file', params['file'] as any)
        }
      }

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static getListCustomerInfo1(
    params: {
      /** Từ khóa */
      keyword?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/search'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { keyword: params['keyword'], page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static exportFileData(
    params: {
      /**  */
      file: any
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/upload'

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options)

      const data = new FormData()
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any)
          }
        } else {
          data.append('file', params['file'] as any)
        }
      }

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createListCustomer(
    params: {
      /** requestBody */
      body?: CreateCustomerRequest[]
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/list'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class ProviderService {
  /**
   *
   */
  static getListProvider(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static getListInboundProvider(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/inbound/trunk'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   *
   */
  static createProvider(
    params: {
      /** requestBody */
      body?: CreateProviderRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static createInboundProvider(
    params: {
      /** requestBody */
      body?: CreateProviderRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/inbound/trunk'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /** */
  static getProviderDetail(
    params: {
      sipTrunkId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk/{sipTrunkId}'
      url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

    /** */
    static getInboundProviderDetail(
      params: {
        sipTrunkId: string
      } = {} as any,
      options: IRequestOptions = {}
    ): Promise<any> {
      return new Promise((resolve, reject) => {
        let url = basePath + '/provider/inbound/trunk/{sipTrunkId}'
        url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');
        const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

        let data = null
        configs.data = data
        axios(configs, resolve, reject)
      })
    }

  static editProvider(
    params: {
      sipTrunkId?: string,
      /** requestBody */
      body?: CreateProviderRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk/{sipTrunkId}'
      url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static editInboundProvider(
    params: {
      sipTrunkId?: string,
      /** requestBody */
      body?: CreateProviderRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/inbound/trunk/{sipTrunkId}'
      url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static deleteProvider(
    params: {
      sipTrunkId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk/{sipTrunkId}'
      url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');
      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static deleteInboundProvider(
    params: {
      sipTrunkId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/inbound/trunk/{sipTrunkId}'
      url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');
      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class AccountService {
  /**
   *
   */
  static getAccountInfo(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updateAccountInfo(
    params: {
      /** requestBody */
      body?: UpdateAccountRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account'

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updatePassword(
    params: {
      /** requestBody */
      body?: UpdatePasswordRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/password'

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static activeAccount(
    params: {
      /** requestBody */
      body?: ActiveAccountRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/active'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   *
   */
  static updatePasswordForget(
    params: {
      /** requestBody */
      body?: UpdatePasswordForgetRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/password/forget'

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Tạo tài khoản TCK2
   */
  static createAccountTck2(
    params: {
      /** requestBody */
      body?: {
        username: string
        password: string
        firstName: string
        lastName: string
        phoneNumber: string
        email: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + 'organization/member/tck2'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Lấy danh sách tài khoản con
   */
  static getAccountChildren(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/account/tck2'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Xóa tài khoản con
   */
  static deleteAccountChild(
    params: {
      /** ID tài khoản cần xóa */
      id: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/child/{id}'
      url = url.replace('{id}', params['id'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Cập nhật thông tin tài khoản con
   */
  static updateAccountChild(
    params: {
      /** ID tài khoản cần cập nhật */
      id: string,
      /** requestBody */
      body?: {
        last_name?: string
        first_name?: string
        phone_number?: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/child/{id}'
      url = url.replace('{id}', params['id'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Khóa tài khoản con
   */
  static lockAccountChild(
    params: {
      /** ID tài khoản cần khóa */
      id: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/child/{id}/lock'
      url = url.replace('{id}', params['id'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Tìm kiếm tài khoản
   */
  static searchAccount(
    params: {
      keyword: string
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/search'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { keyword: params.keyword }
      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Mời tài khoản con vào hệ thống
   */
  static inviteAccountChild(
    params: {
      /** ID tài khoản con cần mời */
      childAccountId: string[]
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/child/invite'
      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)
      var searchParams = new URLSearchParams();

      for (const id of params.childAccountId) {
        searchParams.append("childAccountId", id);
      }

      configs.params = searchParams
      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class AccountLevel1Service {
  /**
   * Lấy danh sách tài khoản cấp 1
   */
  static getListAccountLevel1(
    params: {
      /** Từ khóa tìm kiếm email */
      keyword?: string
      /** Phân quyền (admin/user/...) */
      role?: string
      /** Trạng thái (1: hoạt động, 0: không hoạt động) */
      status?: number | string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      console.log('params', params)
      let url = basePath + '/admin/account'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        keyword: params['keyword'],
        role: params['role'],
        status: params['status'],
        page: params['page'] ?? 0,
        size: params['size'] ?? 10
      }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }



  /**
   * Tạo mới tài khoản cấp 1
   */
  static createAccountLevel1(
    params: {
      /** requestBody */
      body?: any
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/account'
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      let data = params.body
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Cập nhật tài khoản cấp 1
   */
  static updateAccountLevel1(
    params: {
      /** id tài khoản */
      id: string,
      /** requestBody */
      body?: any
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/account/' + params.id
      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)
      let data = params.body
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Xóa tài khoản cấp 1
   */
  static deleteAccountLevel1(
    params: {
      /** id tài khoản */
      id: string
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/account/' + params.id
      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)
      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Reset mật khẩu tài khoản cấp 1
   */
  static resetPasswordLevel1(
    params: {
      /** id tài khoản */
      id: string
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/account/{id}/password/reset'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class OtpService {
  /**
   *
   */
  static getOtpDefindByMail(
    params: {
      /** Service code. (signup: service đăng kí) */
      serviceCode: string
      /** Email nhận otp */
      email: string
      /** Loại otp. (1: Đăng kí; 2: Reset password) */
      type: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/otp'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { service_code: params['serviceCode'], email: params['email'], type: params['type'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export interface UpdatePasswordForgetRequest {
  /** Email */
  email: string

  /** Mật khẩu */
  password: string

  /** Xác nhận mật khẩu */
  confirm_password: string

  /** OTP */
  otp: string
}

export interface ActiveAccountRequest {
  /** Email */
  email: string

  /** OTP */
  otp: string
}

export interface CreateProviderRequest {
  /** name */
  name: string

  /** address */
  address: string

  /** phone_numbers */
  phone_numbers: string[]

  /** username */
  username: string

  /** password */
  password: string
}

export interface UpdatePasswordRequest {
  /** Email */
  email: string

  /** Mật khẩu */
  password: string

  /** Xác nhận mật khẩu */
  confirm_password: string

  /** OTP */
  otp: string
}

export interface UpdateAccountRequest {
  /** Họ */
  last_name?: string

  /** Tên */
  first_name?: string

  /** Số điện thoại */
  phone_number?: string
}

export interface UpdateCustomerRequest {
  /** Tên khách hàng */
  name?: string

  /** Email khách hàng */
  email?: string

  /** Giới tính (1: Nam, 2: Nữ) */
  sex?: number

  /** Địa chỉ */
  address?: string

  phone_number: string
}

export interface CreateCustomerRequest {
  /** Tên khách hàng */
  name?: string

  /** Email khách hàng */
  email?: string

  /** Số điện thoại khách hàng */
  phone_number: string

  /** Giới tính (1: Nam, 2: Nữ) */
  sex?: number

  /** Địa chỉ */
  address?: string
}

export interface CreateCampaignRequest {
  id?: string
  stt?: string
  /** Tên chiến dịch */
  name?: string

  /** Id kịch bản */
  scenario?: any

  scenario_id?: string

  agent?: any
  agent_id?: string

  /** Id giọng đọc */
  voice_id: string
  voice?: any

  /** Tốc độ đọc */
  voice_speed?: number

  /** Danh sách id người dùng */
  customer_ids?: string[]

  customer?: any

  /** Ngày bắt đầu */
  start_date?: number

  /** Ngày kết thúc */
  end_date?: number

  /** Khung giờ */
  time_frames?: TimeFrame[]

  /** Thời lượng tối đa (s) */
  max_call_duration?: number

  /** Số cuộc gọi đồng thời */
  parallel_call_count?: number

  /** Điều kiện gọi lại (1: Khi máy bận; 2: Vào thư thoại; 3: Không nghe máy; 4: Không gọi được) */
  recall_condition?: any

  /** Số lần gọi lại */
  retry_count?: number

  /** Thời gian chờ gọi lại */
  retry_delay_time?: number

  /** Nhóm người dùng(1: Nhóm đầu số hệ thống; 2: Nhóm đầu số cá nhân) */
  group?: string

  /** Bot style */
  ai_talk_to_interrupt?: boolean

  /** Cấu hình tin nhắn sau cuộc gọi */
  message_after_call_config?: {
    /** Bật/tắt tính năng gửi tin nhắn sau cuộc gọi */
    enable?: boolean
    /** ID ứng dụng Zalo */
    zalo_app_id?: string
    /** Secret key của ứng dụng Zalo */
    zalo_app_secret?: string
    /** Mã xác thực */
    code_verifier?: string
    /** Token làm mới */
    refresh_token?: string
    /** ID template tin nhắn */
    template_id?: string
    /** Đối tượng nhận tin nhắn (0: Tất cả, 1: Quan tâm, 2: Không quan tâm) */
    target?: number
  }
}

export interface TimeFrame {
  start_time?: string
  start_time_date?: Date
  end_time?: string
  end_time_date?: Date
}

type ICreateCampaignRequestRecallCondition = any

export interface CampaignDetailDTO {
  /** Id chiến dịch */
  id?: string

  /** Tên chiến dịch */
  name?: string

  /** Trạng thái */
  status?: number

  /** Tên kịch bản */
  scenario_name?: string

  /** Tên giọng nói */
  voice_name?: string

  /** Thông tin danh sách khách hàng */
  customers?: CustomerDTO[]

  /** Ngày bắt đầu */
  start_date?: number

  /** Ngày kết thúc */
  end_date?: number

  /** Khung giờ */
  time_frames?: TimeFrame[]

  /** Thời lượng tối đa (s) */
  max_call_duration?: number

  /** Số cuộc gọi đồng thời */
  parallel_call_count?: number

  /** Điều kiện gọi lại (1: Khi máy bận; 2: Vào thư thoại; 3: Không nghe máy; 4: Không gọi được) */
  recall_condition?: any

  /** Số lần gọi lại */
  retry_count?: number

  /** Thời gian chờ gọi lại */
  retry_delay_time?: number
}

export interface CampaignDTO {
  /** Id chiến dịch */
  id?: string

  /** Tên chiến dịch */
  name?: string

  /** Trạng thái */
  status?: number

  /** Tiến độ */
  progress?: number

  /** Tên kịch bản */
  scenario_name?: string

  /** Tên giọng nói */
  voice_name?: string

  /** Ngày bắt đầu */
  start_date?: number

  /** Ngày kết thúc */
  end_date?: number

  /** Tổng số khách hàng */
  customer_count?: number

  /** Số khách hàng chưa gọi */
  customer_not_call_count?: number

  /** Số khách hàng chờ gọi */
  customer_wait_call_count?: number

  /** Số lượng cuộc gọi (s) */
  call_count?: number
}

export interface PageDTOCampaignDTO {
  /**  */
  list?: CampaignDTO[]

  /**  */
  page?: number

  /**  */
  size?: number

  /**  */
  total?: number
}
export interface CustomerDTO {
  /** Id khách hàng */
  id?: string

  /** Tên khách hàng */
  name?: string

  /** Email khách hàng */
  email?: string

  /** Số điện thoại khách hàng */
  phone_number?: string

  /** Giới tính (1: Nam, 2: Nữ) */
  sex?: number

  /** Địa chỉ */
  address?: string

  /** Id tổ chức */
  organization_id?: string
}

export interface RCampaignDetailDTO {
  /**  */
  code?: number

  /**  */
  msg?: string

  /**  */
  data?: CampaignDetailDTO

  /**  */
  ts?: number
}

export interface CreateScenarioActionRequest {
  /** Tên kịch bản hoạt động */
  name?: string

  /** Giới hạn thời gian phản hồi (s) */
  limit_response_time?: number

  /** Bàn phím người dùng */
  keypad?: string

  /** Từ khóa */
  keyword?: string

  /** Lời thoại */
  speech_text?: string

  /**  */
  speech_invalid_text?: string

  /** Id hành động phía trước */
  parent_action_id?: string
}

export interface CreateScenarioRequest {
  /** Tên kịch bản */
  name?: string

  /** Link ảnh kịch bản */
  image_url?: string

  /** Câu nói khi bắt đầu hội thoại */
  start_conversion?: string
}

export interface UpdateScenarioActionRequest {
  /** Tên kịch bản hoạt động */
  name?: string

  /** Giới hạn thời gian phản hồi (s) */
  limit_response_time?: number

  /** Bàn phím người dùng */
  keypad?: string

  /** Từ khóa */
  keyword?: string

  /** Lời thoại */
  speech_text?: string

  /**  */
  speech_invalid_text?: string

  /** Id hành động phía trước */
  parent_action_id?: string
}

export interface UpdateScenarioRequest {
  /** Tên kịch bản */
  name?: string

  /** Link ảnh kịch bản */
  image_url?: string

  /** Bắt đầu cuộc gọi */
  start_conversion?: string
}

/**
 * Đặt mua package
 */
export class PackageService {
  /**
   *
   */
  static orderPackage(
    params: {
      package_id: string
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/order'
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      let data = { package_id: params.package_id }
      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class OrganizationService {
  /**
   * Lấy danh sách tổ chức
   */
  static getOrganizations(
    params: {
      /** Từ khóa tìm kiếm */
      keyword?: string
      /** Chủ sở hữu (owner_id) */
      owner_id?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/admin/organization'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        keyword: params.keyword,
        owner_id: params.owner_id,
        page: params.page ?? 0,
        size: params.size ?? 10
      }
      configs.data = null
      axios(configs, resolve, reject)
    })
  }
  /**
   * Tạo mới tổ chức
   */
  static createOrganization(
    params: {
      /** requestBody */
      body: {
        name: string
        owner_email: string
      }
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/admin/organization'
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }

  /**
   * Lấy chi tiết tổ chức
   */
  static getOrganizationDetail(
    params: { id: string },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/organization/{id}'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Cập nhật tổ chức
   */
  static updateOrganization(
    params: {
      id: string,
      body: {
        name: string
        emails_account_level1: string
      }
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/organization/{id}'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }

  /**
   * Xóa tổ chức
   */
  static deleteOrganization(
    params: { id: string },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/organization/{id}'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Thêm gói vào tổ chức
   */
  static addPackageToOrganization(
    params: { id: string, packageId: string },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/organization/{id}/package'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.params = { packageId: params.packageId }
      configs.data = null
      axios(configs, resolve, reject)
    })
  }


}

export class ContactService {
  /**
   * Tạo contact mới
   */
  static createContact(
    params: {
      body: {
        /** Tên người liên hệ */
        name: string
        /** Email */
        email: string
        /** Số điện thoại */
        phone_number: string
        /** Tên tổ chức */
        organization: string
        /** Nội dung liên hệ */
        content: string
        /** Id gói dịch vụ */
        product_package_id: string
      }
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/contact/'
      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }

  /**
   * Lấy danh sách contact (admin)
   */
  static getAdminContacts(
    params: {
      /** Từ khóa tìm kiếm */
      keyword?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = basePath + '/admin/contact'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        keyword: params.keyword,
        page: params.page ?? 0,
        size: params.size ?? 10
      }
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  /**
   * Cập nhật trạng thái contact (admin)
   */
  static updateAdminContactStatus(
    params: {
      /** ID contact */
      id: string,
      /** requestBody */
      body: {
        /** Trạng thái đơn hàng (0: chưa tạo, 1: đã tạo) */
        order_status?: number
        /** Trạng thái liên hệ (0: chưa liên hệ, 1: đã liên hệ) */
        status?: number
      }
    },
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/admin/contact/{id}'
      url = url.replace('{id}', encodeURIComponent(params.id))
      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }
}
